import { styled } from "goober";
import { useComposerStrip } from "../../hooks/useComposerStrip";
import { mobileMedia } from "../../hooks/useIsMobile";
import { PressButton } from "../PressButton";
import { Icon } from "../Icon";

// Revealed by hovering the whole composer input, which each composer tags with [data-composer].
const IconWrap = styled("span")`
  display: flex;
  opacity: 0;
  transition: opacity 0.2s ease;
  [data-composer]:hover & {
    opacity: 0.4;
  }
  ${mobileMedia} {
    opacity: 0.4;
  }
`;

const Hint = styled("span")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: var(--text-secondary);
  background-color: transparent;
  transform: translateY(4px);
  transition:
    background-color 0.2s ease,
    transform 0.2s ease;
  [data-composer]:hover & {
    background-color: var(--alpha4);
    transform: translateY(0);
  }
  ${mobileMedia} {
    background-color: var(--alpha4);
    transform: translateY(0);
  }
`;

const Spacer = styled(PressButton)`
  flex: 1;
  align-self: stretch;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export function ComposerStripToggle() {
  const { open, toggle } = useComposerStrip();
  return (
    <Spacer
      data-no-pill
      onMouseDown={(e) => e.preventDefault()}
      onPress={toggle}
    >
      <Hint>
        <IconWrap>
          <Icon
            name="chevron-up"
            size={12}
            style={{
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease",
            }}
          />
        </IconWrap>
      </Hint>
    </Spacer>
  );
}
